<script setup>
const $userStore = useUserStore();
</script>

<template>
  <ClientOnly>
    <template #default>
      <AtomImageNuxtImage
        v-if="$userStore.user.avatar"
        draggable="false"
        class="inline-block size-8 rounded-full object-cover lg:size-10"
        :src="$userStore.user.avatar"
        resize="100x100"
        bucket-alias="avatars"
        alt="Avatar"
      />
      <AtomImageUserAvatarDefault
        v-else
        class="inline-block size-8 rounded-full object-cover lg:size-10"
      />
    </template>
    <template #fallback>
      <div class="size-8 animate-pulse rounded-full bg-gray-300 lg:size-10" />
    </template>
  </ClientOnly>
</template>

<style scoped>
img:hover {
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.4));
}
</style>
